module.exports = __webpack_public_path__ + "static/media/puzzle-37-bg.95322aec.svg";